<template>
    <v-dialog id="expired-dialog" v-model="dialog" max-width="420px" persistent>
        <v-card :style="fontStyle">
            <v-card-title class="justify-center">
                {{ title }}
            </v-card-title>

            <v-card-text class="text-center">
                {{ text }}
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import fontMixin from "@/mixins/fontMixin.js";

export default {
    name: "ExpiredDialog",
    props: {
        title: String,
        text: String,
    },
    data() {
        return {
            dialog: true,
        };
    },
    mixins: [fontMixin],
};
</script>
